import React, { useState } from "react";
import { useTranslation } from "src/hooks";
import { Text } from "src/components/Text";
import { PassportAssets } from "src/assets";
import { ReactSVG } from "react-svg";
import {
  Box,
  Button,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useModalManagerContext,
  Modal,
} from "src/components";
import styled, { css } from "styled-components";
import { pdfDownloader } from "src/helpers";

const ButtonEl = styled(Button)`
  min-width: ${(p) => p.theme.dimension.width.button}px;
`;

const ModalHeaderContainerEl = styled.div`
  > div {
    margin-bottom: 0;
    padding: ${(p) => p.theme.dimension.spacing.s}px;
  }
`;

const CircleEl = styled.div<{ active?: boolean }>`
  ${(p) => css`
    border-radius: ${p.theme.dimension.borderRadius[1]}px;
    width: ${p.theme.dimension.spacing.s}px;
    height: ${p.theme.dimension.spacing.s}px;
    background-color: ${p.active
      ? p.theme.colors.background.primary
      : p.theme.colors.borders.appBar};
    :not(:first-child) {
      margin-left: ${p.theme.dimension.spacing.s}px;
    }
  `}
`;

const assets = [
  PassportAssets.tooltip.productDescLogo,
  PassportAssets.tooltip.tncLogo,
  PassportAssets.tooltip.contactUsLogo,
  PassportAssets.tooltip.priceLogo,
  PassportAssets.tooltip.checkoutLogo,
];

const TOTAL_CONTENTS = 5;

export const TooltipModal = () => {
  const [contentIndex, setContentIndex] = useState(0);
  const { onClose } = useModalManagerContext();
  const translate = useTranslation();
  const isLastContent = contentIndex === TOTAL_CONTENTS - 1;
  const isFirstContent = contentIndex === 0;

  const onNext = () => {
    if (isLastContent) {
      onClose();
      return;
    }
    setContentIndex(contentIndex + 1);
  };

  const onBack = () => {
    if (isFirstContent) {
      onClose();
      return;
    }
    setContentIndex(contentIndex - 1);
  };

  const onDownload = async () => {
    const tncDoc = require("src/assets/files/midtrans-tnc-template-13-jan-2017.pdf");
    await pdfDownloader(tncDoc, "midtrans-tnc-template-13-jan-2017.pdf");
  };

  const Content = (index: number) => {
    if (
      translate("business_info.tooltip.points")[index].split(";").length > 1
    ) {
      return (
        <Box>
          <Box style={{ minHeight: "42px" }} marginBottomXl>
            <Text marginBottomXl as="span">
              {translate("business_info.tooltip.points")[index].split(";")[0]}
            </Text>
            <Text
              fontWeight="demi"
              color="primary"
              as="span"
              style={{ cursor: "pointer" }}
              onClick={onDownload}
            >
              {translate("business_info.tooltip.points")[index].split(";")[1]}
            </Text>
          </Box>
          <Box marginBottomL flex justifyCenter>
            <ReactSVG src={assets[index]} />
          </Box>
        </Box>
      );
    }
    return (
      <Box>
        <Text marginBottomXl style={{ minHeight: "42px" }}>
          {translate("business_info.tooltip.points")[index]}
        </Text>
        <Box marginBottomL flex justifyCenter>
          <ReactSVG src={assets[index]} />
        </Box>
      </Box>
    );
  };

  const renderStepper = () => {
    let counter = 0;
    const res = [];
    while (counter < TOTAL_CONTENTS) {
      res.push(<CircleEl active={counter === contentIndex} />);
      counter++;
    }
    return res;
  };

  return (
    <Modal height={640}>
      <ModalHeaderContainerEl>
        <ModalHeader />
      </ModalHeaderContainerEl>
      <ModalContent>
        <Text fontWeight="demi" style={{ marginTop: "-16px" }} marginBottomXxl>
          {translate("business_info.tooltip.title")}
        </Text>
        {Content(contentIndex)}
        <Box flex style={{ justifyContent: "center" }}>
          {renderStepper()}
        </Box>
      </ModalContent>
      <ModalFooter>
        <Box flex justifyBetween flexAuto>
          <ButtonEl outline onClick={onBack}>
            {isFirstContent
              ? translate("business_info.tooltip.skip")
              : translate("business_info.tooltip.back")}
          </ButtonEl>
          <ButtonEl onClick={onNext}>
            {isLastContent
              ? translate("business_info.tooltip.skip")
              : translate("business_info.tooltip.next")}
          </ButtonEl>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
